export const moment = window['moment'];
export const iziToast = window['iziToast'];
export const MicroModal = window['MicroModal'];
export const swal = window['swal'];
export const page = window['page'];
